const frequency = [
  { label: "Never", value: "1" },
  { label: "1 - 2 times", value: "2" },
  { label: "3 - 4 times", value: "3" },
  { label: "5 - 6 times", value: "4" },
  { label: "Daily", value: "5" },
];

export default frequency;